export default __webpack_public_path__ + "static/media/groupMembers.aea53265.svg";